class EqualHeight {
    constructor() {
        this.selector = '[data-equal-height]';
        this.elements = document.querySelectorAll(this.selector);

        if(!this.elements.length) return;

        this.debounceTimer;
        this.init();
    }

    init() {
        this.adjustHeight();
        window.addEventListener('resize', this.debounce(() => this.adjustHeight(), 200));
    }

    adjustHeight() {
        this.elements.forEach(parent => {
            const allowedMedia = parent.dataset.equalHeight;
            const resizeAllowed = window.matchMedia(`(${allowedMedia})`).matches || !allowedMedia
            const items = parent.querySelectorAll('.equal-height-item');
            let maxHeight = 0;

            if (resizeAllowed) {
                items.forEach(item => {
                    const clone = item.cloneNode(true);
                    clone.style.visibility = 'hidden';
                    clone.style.height = 'auto';
                    clone.style.position = 'absolute';
                    clone.style.top = '-9999px';
                    clone.style.left = '-9999px';
                    clone.style.width = `${item.getBoundingClientRect().width}px`;
                    const parentEl = item.parentNode;

                    parentEl.appendChild(clone);

                    const height = clone.getBoundingClientRect().height;
                    if (height > maxHeight) {
                        maxHeight = height;
                    }

                    parentEl.removeChild(clone);
                });

                items.forEach(item => {
                    item.style.height = `${maxHeight}px`;
                });
            } else {
                items.forEach(item => {
                    item.style.height = '';
                });
            }
        });
    }

    debounce(func, wait) {
        return (...args) => {
            const context = this;
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => func.apply(context, args), wait);
        }
    }
}

export default EqualHeight;
